<template>
  <div class="footer" id="footer">
    <div class="footer-list" >
      <div class="footer-left">
        <div class="footerTitle">400-168-0661</div>
        <div class="productNameList">
          <div class="footer_font">
            <div>工作时间: 8:30-23:00</div>
          </div>
          <div class="footer_font">
            <div>Email: hnnavi@navi-sci.cn</div>
          </div>
            <div class="footer_menu">
              <span @click="toUrl('https://www.navi-sci.cn/')">首页</span>
              <el-divider direction="vertical"></el-divider><span @click="toUrl('https://www.navi-sci.cn/materialTest?type=2')">材料检测</span>
              <el-divider direction="vertical"></el-divider><span @click="toUrl('https://www.navi-sci.cn/cloudScene?type=1')">云现场</span>
              <el-divider direction="vertical"></el-divider><span @click="toUrl('https://www.navi-sci.cn/aboutUsList?type=13')">关于纳微</span>
              <el-divider direction="vertical"></el-divider>FIB聚焦离子束
            </div>
        </div>
      </div>
        <div class="footer_center">
        <div class="footer_img" style="margin-right: 80px;">
          <img src="../../assets/img/gzh.png" alt="纳微创新企业二维码"/>
          <div class="footer_center_font">企业二维码</div>
        </div>
        <div class="footer_img">
          <img src="../../assets/img/xcx.png" alt="纳微创新小程序二维码"/>
          <div class="footer_center_font">小程序二维码</div>
        </div>
        </div>
        <div class="footer_address">
          总部地址：湖南省长沙市岳麓区岳麓街道科技创意园8栋负一楼
        </div>
    </div>
    <el-divider></el-divider>
    <a class="banquan" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
      ICP备案号：湘ICP备20210169-1
    </a>
  </div>
</template>
<script>
export default {
  methods: {
    toLink(path, type) {
      this.$router.push({ path: path, query: { type: type } });
    },
    toOther() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    toUrl(url){
      window.location.href = url
    },
  }
};
</script>
<style>
#footer .el-divider {
  background-color: #E5E5E5;
}
</style>
<style scoped lang="less">
.link {
  cursor: pointer;
}
.link:hover {
  color: #1c6cb5;
}
.footer {
  background: #272A29;
}
.footer-list {
  width: 80%;
  max-width: 1920px;
  min-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  padding: 50px 0 20px 50px;
}
.banquan {
  cursor: default;
  display: block;
  width: 80%;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #F4F4F4;
  padding-bottom: 20px;
  line-height: 30px;
}
.banquan:hover {
  text-decoration: underline;
}
.footer-left {
  width: 40%;
}
.footerTitle {
  font-size: 36px;
  font-weight: 500;
  color: #F4F4F4;
  
}
.productNameList {
  font-weight: 400;
  color: #F4F4F4;
  font-size: 14px;
  line-height: 35px;
  margin-top: 20px;
}
.footer_center {
  width: 25%;
  display: flex;
  flex-flow: row nowrap;
  color: #F4F4F4;
  font-size: 14px;
  text-align: center;
}
.footer_img {
   img {
     width: 112px;
    height: 112px;
   }
  
}
.footer_center_font {
  height: 60px;
  line-height: 60px;
}
.footer_font {
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.footer_address {
  width: 35%;
  color: #F4F4F4;
  margin-top: 50px;
}
.footer_menu{
  span{
    cursor: pointer;
  }
}
</style>
